// src/screens/TermsOfServicePage.jsx
import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

const TermsOfServicePage = () => {
  return (
    <>
      <Header />
      <div className="page-with-footer">
        <main className="page-main">
          <div className="site-shell">
            <div className="site-shell-inner">
              <section className="pt-5 pb-2 text-center">
                <h1 className="fw-bold display-5 mb-3" style={{color: "#A30003" }}>
                  Términos del Servicio
                </h1>
                <p
                  className="text-muted fs-5 mx-auto"
                  style={{ maxWidth: "900px", color: "#A30003" }}
                >
                  Establecemos reglas claras para garantizar una experiencia
                  segura, transparente y confiable en cada interacción con
                  nuestra plataforma.
                </p>
              </section>

              <section className="py-4">
                <div className="row justify-content-center">
                  <div className="col-lg-9">
                    <p className="fs-5 text-muted lh-lg" style={{ textAlign: "justify" }}>
                      Al realizar compras en <strong>AltaModa</strong>{" "}
                      aceptas las condiciones aquí descritas. Precios,
                      promociones y disponibilidad pueden cambiar sin previo
                      aviso.
                    </p>

                    <p className="fs-5 text-muted lh-lg" style={{ textAlign: "justify" }}>
                      La compra se realiza mediante asesoría directa, por lo que el cliente es responsable de validar tallas, colores y características del producto antes de confirmar el pedido.
                    </p>

                    <p className="fs-5 text-muted lh-lg pb-4" style={{ textAlign: "justify" }}>
                      Nos reservamos el derecho de cancelar pedidos en caso de errores evidentes, falta de disponibilidad o situaciones que afecten la operación, informando oportunamente al cliente.
                    </p>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default TermsOfServicePage;
